import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';

export interface TeamMonthlyPlanRequest {
  year: number;
  month: number;
  plan: string;
  is_bonus_active?: boolean;
  bonus_manager?: number | null;
}

export interface TeamMonthlyPlanDto {
  id: number;
  year: number;
  month: number;
  plan: string;
  is_bonus_active: boolean;
  bonus_manager: number | null;
}

const updateManagersMonthlyPlan = async (
  data: TeamMonthlyPlanRequest
): Promise<TeamMonthlyPlanDto> => {
  const response = await api.post<TeamMonthlyPlanDto>(
    `${PANEl_BASE_URL}/general/monthly-plan/create_by_params/`,
    data
  );

  return response.data;
};

export const useUpdateManagersMonthlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateManagersMonthlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    updateTeamMonthlyPlan: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};